import { render, staticRenderFns } from "./HeaderWithTitleAndIcon.vue?vue&type=template&id=07ec8313&scoped=true"
import script from "./HeaderWithTitleAndIcon.vue?vue&type=script&lang=js"
export * from "./HeaderWithTitleAndIcon.vue?vue&type=script&lang=js"
import style0 from "./HeaderWithTitleAndIcon.vue?vue&type=style&index=0&id=07ec8313&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ec8313",
  null
  
)

export default component.exports